<template>
  <div
    id="seasidetms_row_why"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <h3 class="seasidetms_heading">
            {{ $t('home.why') }} <b>"AppTown"</b>?
          </h3>
          <div
            class="seasidetms_row_margin seasidetms_14141414"
            style="
              text-align: justify;
              font-size: 16px;
              line-height: 24px;
              color: #1b1818;
            "
            v-html="$t('home.whyus')"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyUs',
}
</script>

<style>
/* .seasidetms_heading{
    margin: 0 -1.37% 20px;
  } */
</style>
